import moment from 'moment';
import useArticle from '../../ArticleOverview/hooks/useArticle';
import image from './image_1.png';

const useStory = () =>
    useArticle({
        title: 'Stichting Sarfath 25 jaar!',
        date: moment('2026-03-27 10:00'),
        image: image,
        summary: (
            <>
                In maart 2001 is Stichting Sarfath opgericht — dat is inmiddels
                25 jaar geleden! Een bijzonder moment om bij stil te staan en
                vooruit te kijken naar de toekomst.
            </>
        ),
        content: (
            <>
                <div className="row mb-3">
                    <div className="col-12 col-md-4">
                        <img
                            src={image}
                            className="img-fluid img-thumbnail"
                            alt="25 jaar Stichting Sarfath"
                        />
                    </div>
                    <div className="col">
                        <p>
                            In maart 2001 is Stichting Sarfath opgericht — dat
                            is inmiddels 25 jaar geleden! Al die tijd zijn velen
                            betrokken geweest bij het reilen en zeilen van de
                            stichting en hebben zij het werk voor de kansarme
                            kinderen in Egypte ondersteund. Bevlogen werkers
                            zijn daar dag aan dag met veel inzet en liefde bezig
                            om in moeilijke en soms uitzichtloze situaties licht
                            te brengen. We mogen in alles de Hand van onze God
                            zien. Het is heel fijn en bijzonder om te horen dat
                            het werk daar mag groeien!
                        </p>
                    </div>
                </div>

                <h5>Uitdagingen</h5>
                <p>
                    Jammer is het dat er om de paar jaar weer omgezien moet
                    worden naar een nieuwe locatie. Elke keer wordt de huur weer
                    opgezegd en dan moet het werk ergens anders weer opgezet
                    worden. Voor werkers en kinderen is dat erg frustrerend en er
                    zijn veel extra kosten mee gemoeid. Daarom zijn er nu
                    plannen om naar een eigen gebouw te gaan kijken — u begrijpt
                    dat daar heel wat voor nodig is!
                </p>

                <h5>Nieuwe plannen</h5>
                <p>
                    Het bestuur van Stichting Sarfath deelt graag deze mijlpaal
                    van 25 jaar. En ja, misschien is het mogelijk het werk in
                    Egypte met een extra gift te steunen? We hebben echt wel een
                    heel aantal adressen nodig en veel kleintjes maken één
                    grote…! Het zou heel fijn zijn om ook deze nieuwe plannen te
                    ondersteunen en mogelijk te maken!
                </p>

                <h5>Nieuw logo</h5>
                <p>
                    Ter gelegenheid van dit jubileum is ook het nieuwe logo
                    onthuld! Er is geprobeerd om meer uitdrukking te geven aan
                    de verbondenheid tussen Nederland en Egypte.
                </p>

                <p>
                    Mocht u een bijdrage willen doen ter gelegenheid van 25 jaar
                    Sarfath, vermeld dan bij uw gift dat het voor een eigen
                    gebouw is. We hopen op een positieve reactie!
                </p>
            </>
        ),
    });

export default useStory;
